import { VendingPackageVolumeWeekdayHeatmapChart, hasChartSeries } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast6MonthsVendingPackageVolumeWeekdayHeatmapChart } from './use-last-6-months-vending-package-volume-weekday-heatmap-chart';

export interface Last6MonthsVendingPackageVolumeWeekdayHeatmapChartProps {
    accountId: string;
}

export const Last6MonthsVendingPackageVolumeWeekdayHeatmapChart = (props: Last6MonthsVendingPackageVolumeWeekdayHeatmapChartProps) => {
    const { data, isLoading, rangeStart } = useLast6MonthsVendingPackageVolumeWeekdayHeatmapChart(props);

    return (
        <StatisticsCard
            chartKey={VendingPackageVolumeWeekdayHeatmapChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.vending.last-6-months-vending-package-volume-weekday-heatmap-chart.title'
                    description='Title of the vending dashboard heatmap showing consumption volume by weekday over the last six months'
                    defaultMessage='Consumption heatmap'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.statistics.vending.last-6-months-vending-package-volume-weekday-heatmap-chart.subtitle'
                    description='Subtitle on the vending consumption heatmap indicating the chart covers the last six months with daily bins grouped by week'
                    defaultMessage='last 6 months'
                />
            }
            isLoading={isLoading}
            hasData={hasChartSeries(data)}>
            {hasChartSeries(data) && data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <VendingPackageVolumeWeekdayHeatmapChart
                        data={data}
                        rangeStart={rangeStart}
                        minHeight={220}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
